import App from './components/app/App';
import { RESOURCES_ACCESS } from '../../global/app-global-values';
import React from 'react';

const TerminologyData = () => <App />;

export default {
  routeProps: {
    path: '/terminology-data',
    component: TerminologyData,
  },
  name: 'TerminologyData',
  label: 'Terminology Data',
  iconClassName: 'icon-books',
  active: true,
  accessGroup: RESOURCES_ACCESS,
};
